var map = {
	"./favicon/logo": 304,
	"./favicon/logo.png": 304,
	"./favicon/safari-pinned-tab": 305,
	"./favicon/safari-pinned-tab.svg": 305,
	"./placeholder/placeholder-16x9": 306,
	"./placeholder/placeholder-16x9.jpg": 306,
	"./placeholder/placeholder-1x1": 307,
	"./placeholder/placeholder-1x1.jpg": 307,
	"./placeholder/placeholder-1x1_5": 308,
	"./placeholder/placeholder-1x1_5.jpg": 308,
	"./placeholder/placeholder-2x1": 309,
	"./placeholder/placeholder-2x1.jpg": 309,
	"./placeholder/placeholder-32x9": 310,
	"./placeholder/placeholder-32x9.jpg": 310,
	"./placeholder/placeholder-3x2": 311,
	"./placeholder/placeholder-3x2.jpg": 311,
	"./placeholder/placeholder-3x4": 312,
	"./placeholder/placeholder-3x4.jpg": 312,
	"./placeholder/placeholder-8x9": 313,
	"./placeholder/placeholder-8x9.jpg": 313,
	"./schema/logo": 314,
	"./schema/logo.png": 314,
	"./social_sharing/facebook": 315,
	"./social_sharing/facebook.png": 315,
	"./social_sharing/twitter": 316,
	"./social_sharing/twitter.png": 316,
	"./template/SAF-email-footer": 317,
	"./template/SAF-email-footer.png": 317,
	"./template/SAF-email-header": 318,
	"./template/SAF-email-header.png": 318,
	"./template/arrow-down": 183,
	"./template/arrow-down.png": 183,
	"./template/arrow-down.svg": 448,
	"./template/arrow-left": 184,
	"./template/arrow-left.png": 184,
	"./template/arrow-left.svg": 449,
	"./template/arrow-right": 185,
	"./template/arrow-right.png": 185,
	"./template/arrow-right.svg": 450,
	"./template/arrow-up": 186,
	"./template/arrow-up.png": 186,
	"./template/arrow-up.svg": 451,
	"./template/basket": 319,
	"./template/basket.svg": 319,
	"./template/cta_bread_01": 320,
	"./template/cta_bread_01.svg": 320,
	"./template/cta_meat_01": 321,
	"./template/cta_meat_01.svg": 321,
	"./template/download": 187,
	"./template/download.png": 187,
	"./template/download.svg": 452,
	"./template/email": 322,
	"./template/email.svg": 322,
	"./template/icon--download": 323,
	"./template/icon--download.svg": 323,
	"./template/icon--link-external": 324,
	"./template/icon--link-external.svg": 324,
	"./template/icon--map-marker_smaller": 325,
	"./template/icon--map-marker_smaller.svg": 325,
	"./template/insta": 326,
	"./template/insta.svg": 326,
	"./template/logo": 327,
	"./template/logo.svg": 327,
	"./template/logos/fdq": 328,
	"./template/logos/fdq.png": 328,
	"./template/logos/icsa": 329,
	"./template/logos/icsa.png": 329,
	"./template/logos/miele": 330,
	"./template/logos/miele.png": 330,
	"./template/logos/nottstrent": 331,
	"./template/logos/nottstrent.png": 331,
	"./template/logos/placeholder-logo-square": 332,
	"./template/logos/placeholder-logo-square.png": 332,
	"./template/logos/placeholder-logo-tall": 333,
	"./template/logos/placeholder-logo-tall.png": 333,
	"./template/logos/placeholder-logo-wide": 334,
	"./template/logos/placeholder-logo-wide.png": 334,
	"./template/logos/visitengland": 335,
	"./template/logos/visitengland.png": 335,
	"./template/map-pin": 336,
	"./template/map-pin.png": 336,
	"./template/menu": 337,
	"./template/menu.svg": 337,
	"./template/placeholder": 338,
	"./template/placeholder.png": 338,
	"./template/quotemark": 339,
	"./template/quotemark.svg": 339,
	"./template/search": 340,
	"./template/search.svg": 340,
	"./template/select-arrow-down": 188,
	"./template/select-arrow-down.png": 188,
	"./template/select-arrow-down.svg": 453,
	"./template/spacer": 341,
	"./template/spacer.gif": 341,
	"./template/stripe_logo": 342,
	"./template/stripe_logo.svg": 342,
	"./template/tick": 189,
	"./template/tick.png": 189,
	"./template/tick.svg": 454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 447;